const S3_URL = process.env.REACT_APP_DATA_FILES_S3_BUCKET_URL;


export async function fetchForecastData() {
    const response = await fetch(`${S3_URL}/forecast_data.json`);
    return await response.json();
}

export async function fetchSitesData() {
    const response = await fetch(`${S3_URL}/sites_data.json`);
    return await response.json();
}

export async function fetchSitesPerRegion() {
    const response = await fetch(`${S3_URL}/sites_per_region.json`);
    return await response.json();
}

export async function fetchMapRegionsGeoJson() {
    const response = await fetch(`/regions.geojson`);
    const responseMobile = await fetch(`/regions_mobile.geojson`);
    return {
        regions: await response.json(),
        regionsMobile: await responseMobile.json(),
    }
}
